import { FormGroup } from '@angular/forms';
import { IAutoSave } from './IAutoSave';
import { AutoSaveContext } from './AutoSaveContext';
import { ChangeDetectorRef } from '@angular/core';

export class AutoSaveFormGroup extends FormGroup implements IAutoSave {
  autoSaveContext = new AutoSaveContext();
  timer: any;
  changeDetectionRef: ChangeDetectorRef;

  private detectChanges(): void {
    if (this.changeDetectionRef) {
      this.changeDetectionRef.markForCheck();
    }
  }

  patchValue(value: any,
             options?: {
               onlySelf?: boolean;
               emitEvent?: boolean;
               emitModelToViewChange?: boolean;
               emitViewToModelChange?: boolean;
             }): void {
    super.patchValue(value, options);
    if (!this.dirty && !this.invalid) {
      this.setupInitialValueState();
    }
  }

  saveSuccess(model, ): void {
    var newContext = new AutoSaveContext();
    newContext.saving = false;
    newContext.removing = false;
    newContext.saved = true;
    newContext.hasSavedValidValue = true;
    this.setErrors({
      ...this.errors,
      'server': false
    });
    newContext.valid = this.valid;
    newContext.errors = this.errors;
    this.autoSaveContext = newContext;
    this.markAsPristine();
    this.patchValue(model);
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
        if (!this.autoSaveContext.saving) {
          this.autoSaveContext = {
            ...this.autoSaveContext,
            saved: false
          };
      }
        this.detectChanges();
      },
      5000);
  }

  saveErrors(model, errors: string[]): void {
    var newContext = new AutoSaveContext();
    newContext.saving = false;
    newContext.removing = false;
    newContext.saved = false;
    newContext.hasSavedValidValue = false;
    newContext.serverErrors = errors;
    this.setErrors({
      ...this.errors,
      'server': true
    });
    newContext.valid = this.valid;
    newContext.errors = this.errors;
    this.autoSaveContext = newContext;
    this.detectChanges();
  }

  initializeRemove(): void {
    this.initializeSave();
    this.autoSaveContext = {
      ...this.autoSaveContext,
      removing: true
    };
    this.detectChanges();
  }

  initializeSave(): void {
    this.autoSaveContext = {
      ...this.autoSaveContext,
      saving: true
    };
    this.detectChanges();
  }

  setupInitialValueState(): void {
    this.autoSaveContext = {
      ...this.autoSaveContext,
      hasSavedValidValue: true
    };
    this.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/AutoSaveFormGroup.ts